import React from 'react';
import { Link } from 'react-router-dom';

const styles = {
  page: {
    minHeight: '100vh',
    background: '#18181B',
    color: '#B5B5BC',
    padding: '80px 6vw',
    maxWidth: 720,
    margin: '0 auto',
  },
  back: {
    color: '#C9A66B',
    textDecoration: 'none',
    fontSize: 13,
    display: 'inline-block',
    marginBottom: 32,
  },
  eyebrow: {
    display: 'block',
    fontFamily: "'Space Mono', monospace",
    fontSize: 13,
    letterSpacing: 2,
    textTransform: 'uppercase',
    color: '#C9A66B',
    marginBottom: 16,
  },
  title: {
    fontFamily: "'Unbounded', sans-serif",
    fontWeight: 900,
    fontSize: 'clamp(32px, 5vw, 48px)',
    color: '#F5F3ED',
    marginBottom: 24,
  },
  desc: {
    fontSize: 16,
    lineHeight: 1.7,
    marginBottom: 40,
  },
  card: {
    background: '#1D1D20',
    border: '1px solid #303034',
    borderRadius: 12,
    padding: 28,
    marginBottom: 20,
  },
  cardLabel: {
    fontSize: 12,
    letterSpacing: 1,
    textTransform: 'uppercase',
    color: '#6E6E76',
    marginBottom: 8,
  },
  cardValue: {
    fontSize: 18,
    color: '#F5F3ED',
    fontWeight: 700,
  },
  link: {
    color: '#C9A66B',
    textDecoration: 'none',
  },
};

export default function Contact() {
  return (
    <div style={styles.page}>
      <Link to="/" style={styles.back}>← Beranda</Link>
      <span style={styles.eyebrow}>Hubungi Kami</span>
      <h1 style={styles.title}>Kontak</h1>
      <p style={styles.desc}>
        Ada pertanyaan soal kerja sama, distribusi lagu, kolaborasi artis, atau butuh bantuan
        seputar akun kamu di Saskara Record? Tim kami siap membantu.
      </p>

      <div style={styles.card}>
        <p style={styles.cardLabel}>Email</p>
        <p style={styles.cardValue}>
          <a href="mailto:info@saskararecord.com" style={styles.link}>info@saskararecord.com</a>
        </p>
      </div>

      <div style={styles.card}>
        <p style={styles.cardLabel}>Untuk Artis & Musisi</p>
        <p style={{ ...styles.cardValue, fontSize: 15, fontWeight: 400 }}>
          Tertarik bergabung dengan Saskara Record? Kirimkan portofolio dan detail karya kamu
          melalui email di atas dengan subjek "Pengajuan Kerja Sama Artis".
        </p>
      </div>

      <div style={styles.card}>
        <p style={styles.cardLabel}>Bantuan Akun & Pesanan</p>
        <p style={{ ...styles.cardValue, fontSize: 15, fontWeight: 400 }}>
          Kalau kamu mengalami kendala login, reset password, atau status pesanan merchandise,
          silakan email kami dengan menyertakan email akun yang terdaftar.
        </p>
      </div>

      <p style={{ fontSize: 13, color: '#6E6E76', marginTop: 32 }}>
        Baca juga <Link to="/privacy-policy" style={styles.link}>Kebijakan Privasi</Link> kami.
      </p>
    </div>
  );
}
